import type { ColumnMappingItem, MediaType } from '@ooh/contracts';

export function columnsRequest(
  importJobId: number,
  supplierId?: string,
  mediaTypeOverride?: MediaType,
  sheetName?: string,
) {
  return {
    id: importJobId,
    ...(supplierId ? { supplierId } : {}),
    ...(mediaTypeOverride ? { mediaTypeOverride } : {}),
    ...(sheetName ? { sheetName } : {}),
  };
}

export function confirmRequest(
  importJobId: number,
  mappings: ColumnMappingItem[],
  saveForSupplierId?: string,
  mediaTypeOverride?: MediaType,
) {
  return {
    id: importJobId,
    mappings,
    saveForSupplierId,
    ...(mediaTypeOverride ? { mediaTypeOverride } : {}),
  };
}
